import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class TaskAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Tasks';


  /**
   * Thực hiện đồng bộ danh mục từ bumas
   * @param {*} taskEntities 
   * @param {*} isInsert 
   * PTTAM2 12/03/2023
   */
 async insertDataBumas(param) {
    let request = {
      url: this.getAPIUrl() + `/insertDataBumas`,
      data: {
        ...param
      }
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện map dữ liệu từ bumas
   * @param {*} param 
   * @returns 
   * PTTAM2 12/03/2023
   */
  async syncTaskBumas(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/syncTaskBumas',
      data: {
        ...param
      }
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Thực hiện kiểm tra phát sinh danh mục
   * @param {*} param 
   * PTTAM2 12/03/2023
   */
  async checkAriseTask(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/checkAriseTask',
      data: {
        budgetYear:param
      }
    };

    return await httpClient.postAsync(request);
  }
   /**
   * Thực hiện đồng bộ lại danh mục khi nhiệm vụ đã phát sinh hạch toán
   * @param {*} param 
   * PTTAM2 12/03/2023
   */
  async insertTaskWhenArrise(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/insertTaskWhenArrise',
      data: {
        budgetYear:param
      }
    };

    return await httpClient.postAsync(request);
  }
}

export default new TaskAPI();
